// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import 'reset-css/reset.css';
import './assets/styles/index.scss';
import App from './App';
import router from './router';
// const ENDPOINT = 'http://122.129.251.120:8001/c03/api/v1';

Vue.use(VeeValidate);
// Vue.use(ENDPOINT);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js